'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxActions = require('redux-actions');

var _pageTitleNotificationsActionTypes = require('../constants/pageTitleNotificationsActionTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = false;

var reducer = _defineProperty({}, _pageTitleNotificationsActionTypes.TOGGLE_SHOWING_PAGE_TITLE_NOTIFICATION, function (state, action) {
  var showing = action.payload.showing;


  return showing;
});

exports.default = (0, _reduxActions.handleActions)(reducer, initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/page-title-notifications/reducers/showingPageTitleNotification.js
// module id = 902
// module chunks = 2 3